export const TABLE_COLUMNS = [
  {
    label: "Order #",
    value: "order #",
    removable: true,
  },
  {
    label: "Date",
    value: "date",
    removable: true,
  },
  {
    label: "Customer",
    value: "customer",
    removable: true,
  },
  {
    label: "UTM Source",
    value: "utm_source",
    removable: true,
  },
  {
    label: "UTM Medium",
    value: "utm_medium",
    removable: true,
  },
  {
    label: "UTM Campaign",
    value: "utm_campaign",
    removable: true,
  },
  {
    label: "UTM Term",
    value: "utm_term",
    removable: true,
  },
  {
    label: "UTM Content",
    value: "utm_content",
    removable: true,
  },
  {
    label: "Order Total",
    value: "total",
    numeric: true,
    removable: true,
  },
];

export const getStartingTableColumns = () => {
  return TABLE_COLUMNS.map(({ value }) => value);
};
